package uz.ferro.erp.ui.header

import emotion.react.css
import mui.icons.material.Close
import mui.icons.material.HelpOutline
import mui.icons.material.Login
import mui.icons.material.Logout
import mui.icons.material.Menu
import mui.icons.material.ShoppingCart
import mui.material.Box
import mui.material.Drawer
import mui.material.DrawerAnchor
import mui.material.IconButton
import mui.material.Size
import mui.material.Stack
import mui.material.StackDirection
import mui.system.responsive
import mui.system.sx
import react.FC
import react.dom.html.ReactHTML.img
import react.useContext
import react.useState
import uz.ferro.erp.Colors
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.feature.auth.LoginDialog
import uz.ferro.erp.manager.AuthManager
import uz.ferro.erp.navigator.NavigationPage
import uz.ferro.erp.pages.MAX_PAGE_AREA
import uz.ferro.erp.ui.AppTextBoldLarge
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.ImageView
import uz.ferro.erp.ui.VerticalLayout
import web.cssom.AlignItems
import web.cssom.Auto
import web.cssom.Cursor
import web.cssom.JustifyContent
import web.cssom.ObjectFit
import web.cssom.Position
import web.cssom.integer
import web.cssom.number
import web.cssom.pct
import web.cssom.px

val HeaderMobile = FC {
    val navigator = useContext(NavigationContext)
    var isDrawerOpened by useState(false)
    var authDialogShown by useState(false)
    var isAuthorized by useState(AuthManager.isAuthorized())

    Box {
        sx {
            width = 100.pct
            height = 48.px
            backgroundColor = Colors.white
        }

        Box {
            sx {
                width = 100.pct
                height = 48.px
            }

            HorizontalLayout {
                sx {
                    width = 100.pct
                    maxWidth = MAX_PAGE_AREA
                    marginLeft = Auto.auto
                    marginRight = Auto.auto
                    alignItems = AlignItems.center
                }

//                IconButton {
//                    Menu {
//                        htmlColor = Colors.accentContrastColorHex
//                    }
//                    onClick = {
//                        isDrawerOpened = !isDrawerOpened
//                    }
//                }

                Box {
                    sx {
                        width = 20.px
                    }
                }

                Box {
                    sx {
                        width = 120.px
                        height = 36.px
                        cursor = Cursor.pointer
                    }

                    ImageView {
                        sx {
                            width = 100.pct
                            height = 100.pct
                        }
                        url = "/icons/ferro_logo.svg"
                    }

                    onClick = {
                        navigator.openMain()
                    }
                }

                Box {
                    sx {
                        flexGrow = number(1.0)
                    }
                }

                IconButton {
                    HelpOutline {
                        htmlColor = Colors.accentContrastColorHex
                    }
                    onClick = {
                        navigator.openPage(NavigationPage.FAQ)
                    }
                }

                if (isAuthorized) {
                    IconButton {
                        ShoppingCart {
                            htmlColor = Colors.accentContrastColorHex
                        }
                        onClick = {
                            navigator.openPage(NavigationPage.ORDER_LIST)
                        }
                    }

                    IconButton {
                        Logout {
                            htmlColor = Colors.accentContrastColorHex
                        }
                        onClick = {
                            AuthManager.logout()
                            isAuthorized = false
                        }
                    }
                } else {
                    IconButton {
                        Login {
                            htmlColor = Colors.accentContrastColorHex
                        }
                        onClick = {
                            authDialogShown = true
                        }
                    }
                }
            }
        }
    }

    Drawer {
        anchor = DrawerAnchor.left
        open = isDrawerOpened
        disableScrollLock = true
        onClose = { _, _ ->
            isDrawerOpened = false
        }

        Stack {
            direction = responsive(StackDirection.column)
            sx {
                minWidth = 300.px
            }

            HorizontalLayout {
                sx {
                    width = 100.pct
                    height = 56.px
                    paddingLeft = 16.px
                    alignItems = AlignItems.center
                    justifyContent = JustifyContent.spaceBetween
                    backgroundColor = Colors.accentColor
                }

                AppTextBoldLarge {
                    text = "Menyu"
                    color = Colors.accentContrastColor
                }

                IconButton {
                    size = Size.small
                    Close {
                        htmlColor = Colors.accentContrastColor.toString()
                    }
                    onClick = {
                        isDrawerOpened = false
                    }
                }
            }

            VerticalLayout {
                sx {
                    padding = 16.px
                }
                // drawer content
            }
        }
    }

    LoginDialog {
        isOpen = authDialogShown
        onClose = {
            authDialogShown = false
        }
        onLoginSuccess = {
            isAuthorized = AuthManager.isAuthorized()
        }
    }
}